import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class LoanRequest_LegitimationChanged extends _Event {
    constructor(payload: EventSchema<LoanRequest_LegitimationChanged>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            legitimation: z.boolean(),
        });
    }

    static example(): EventSchema<LoanRequest_LegitimationChanged> {
        return {
            legitimation: false,
        };
    }
}

// INFO yup schema
// static get SCHEME() {
//     return yup.object({
//         legitimation: yup.boolean().required(),
//     });
// }
